import React from 'react';
import { Mail, Phone, MapPin, Globe, Linkedin, Twitter, Facebook, Youtube } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white">
      {/* Main Footer Content */}
      <div className="container mx-auto px-4 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="flex items-center space-x-3 mb-6">
              <img 
                src="img/logo-1.gif" 
                alt="Air Control Engineering Logo" 
                className="h-10 w-auto"
              />
              <div>
                <h3 className="text-xl font-bold bg-gradient-to-r from-[#0a8ec5] to-[#cd2d31] bg-clip-text text-transparent">Air Control Engineering</h3>
                <p className="text-sm text-gray-300">Pvt. Ltd.</p>
              </div>
            </div>
            <p className="text-gray-300 leading-relaxed mb-6">
              Leading specialists in industrial air pollution control solutions with over 20 years of expertise in creating cleaner, greener industrial environments.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.linkedin.com/company/air-control-in" className="text-gray-400 hover:text-[#0a8ec5] transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="https://www.facebook.com/AirControlEngg/" className="text-gray-400 hover:text-[#0a8ec5] transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="http://www.youtube.com/@AirControlEngineeringKolkata" className="text-gray-400 hover:text-[#0a8ec5] transition-colors">
                <Youtube className="w-5 h-5" />
              </a>
              {/*https://www.indiamart.com/aircontrol-engineering-pvtltd/
              https://www.tradeindia.com/air-control-engineering-pvt-ltd-1589610/
              https://www.justdial.com/Kolkata/AIR-Control-Engineering-Pvt-Ltd-Kolkata-Gpo/033PXX33-XX33-090907081901-W4Y9_BZDET*/}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-6 text-[#0a8ec5]">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => scrollToSection('home')}
                  className="text-gray-300 hover:text-white transition-colors hover:translate-x-1 transform duration-200"
                >
                  Home
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('about')}
                  className="text-gray-300 hover:text-white transition-colors hover:translate-x-1 transform duration-200"
                >
                  About Us
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('products')}
                  className="text-gray-300 hover:text-white transition-colors hover:translate-x-1 transform duration-200"
                >
                  Products & Services
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('projects')}
                  className="text-gray-300 hover:text-white transition-colors hover:translate-x-1 transform duration-200"
                >
                  Projects
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('clientele')}
                  className="text-gray-300 hover:text-white transition-colors hover:translate-x-1 transform duration-200"
                >
                  Clientele
                </button>
              </li>
            </ul>
          </div>

          {/* Our Services */}
          <div>
            <h4 className="text-lg font-semibold mb-6 text-[#cd2d31]">Our Services</h4>
            <ul className="space-y-3 text-gray-300">
              <li className="hover:text-white transition-colors">
                Electrostatic Precipitator (ESP)
              </li>
              <li className="hover:text-white transition-colors">
                Bag Filter Systems
              </li>
              <li className="hover:text-white transition-colors">
                Explosion Vent (Cage Vent)
              </li>
              <li className="hover:text-white transition-colors">
                Industrial Air Handling
              </li>
              <li className="hover:text-white transition-colors">
                Annual Maintenance Contracts
              </li>
              <li className="hover:text-white transition-colors">
                Technical Consultancy
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-6 text-[#0a8ec5]">Contact Info</h4>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-[#cd2d31] mt-1 flex-shrink-0" />
                <div className="text-gray-300">
                  <p>Room 224, 'Centre Point'</p>
                  <p>21, Hemanta Basu Sarani</p>
                  <p>Kolkata 700 001</p>
                </div>
              </div>
              
              <div className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-[#cd2d31] flex-shrink-0" />
                <a 
                  href="tel:+913322364567" 
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  +91 33 2236 4567
                </a>
              </div>
              
              <div className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-[#cd2d31] flex-shrink-0" />
                <a 
                  href="mailto:airoto@air-control.in" 
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  airoto@air-control.in
                </a>
              </div>
            </div>

            {/* Business Hours */}
            <div className="mt-6 p-4 bg-gray-800 rounded-lg border border-gray-700">
              <h5 className="font-semibold text-white mb-2">Business Hours</h5>
              <p className="text-gray-300 text-sm">Monday – Friday</p>
              <p className="text-gray-300 text-sm">10:00 AM – 6:00 PM</p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-700">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-gray-400 text-sm">
              © {currentYear} Air Control Engineering Pvt. Ltd. All Rights Reserved.
            </div>
            <div className="flex items-center space-x-6 text-sm text-gray-400">
              <span>GST: 19AAECA2144G1ZY</span>
              <span>|</span>
              <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
              <span>|</span>
              <a href="#" className="hover:text-white transition-colors">Terms of Service</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;